<template>
	<div v-if="items.length > 0">
		<!-- <h1 class="page-title">Listado de productos</h1> -->

		<VueSlickCarousel
			:arrows="false"
			:dots="true"
			:slidesToScroll="1"
			:slidesToShow="3"
			:responsive="[
				{
					breakpoint: 1720,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
					},
				},
			]"
			class="mt-3"
		>
			<template v-for="item in items">
				<ProductItem :item="item" :key="item.id" />
			</template>
		</VueSlickCarousel>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import ProductItem from '@/components/ProductItem'

export default {
	components: {
		ProductItem,
	},
	data() {
		return {
			items: [],
		}
	},
	beforeMount() {
		this.load()
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($featured: Boolean, $status: String) {
							products(featured: $featured, status: $status) {
								data {
									id
									name
									slug
									price
									image {
										id
										type
										filename
										url
										urlThumb
									}
									featured
								}
							}
						}
					`,
					variables: { featured: true, status: 'ACTIVE' },
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.items = data.products.data
				})
				.catch(() => {})
		},
	},
}
</script>

<style scoped>
div /deep/ .car-item {
	margin: 8px;
}
</style>
